import { Injectable, Injector, Inject, OpaqueToken } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';

import { CookieOptions } from './cookie-options.model';
import { mergeOptions } from './utils';

export const COOKIE_OPTIONS = new OpaqueToken('COOKIE_OPTIONS');

/** @private */
@Injectable()
export class CookieOptionsProvider {

  private defaultOptions: CookieOptions;
  private _options: CookieOptions;

  constructor(@Inject(COOKIE_OPTIONS) options: CookieOptions = {},
              private _injector: Injector) {
    this.defaultOptions = {
      path: this._injector.get(APP_BASE_HREF, '/'),
      domain: null,
      expires: null,
      secure: false
    };
    this._options = mergeOptions(this.defaultOptions, options);
  }

  get options(): CookieOptions {
    return this._options;
  }
}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/common/cookies/src/cookie-options-provider.ts